import { Schema } from "./Schema.js";
/** Define a valid boolean. */
export class BooleanSchema extends Schema {
    constructor({ value = false, ...options }) {
        super({ value, ...options });
    }
    validate(unsafeValue = this.value) {
        return !!unsafeValue;
    }
}
/** Valid boolean. */
export const BOOLEAN = new BooleanSchema({});
